import type { UserRole } from "@edlab-fms/shared";

const ROLE_LABELS: Record<UserRole, string> = {
  super_admin: "Super Admin",
  accounts: "Expense Manager",
  finance_reviewer: "Finance Reviewer",
  board_member: "Board Member",
  project_lead: "Project Lead",
  auditor: "Auditor",
  donor: "Donor",
};

export function formatRoleLabel(role: UserRole): string {
  return ROLE_LABELS[role];
}
